import { Sede } from './usuario.model';
import { Static } from './../util/static';
import { Actividad } from './actividad.model';
import { CampoDinamico } from './global.model';
import { Proceso } from './proceso.model';
import { Microproceso } from './tarea.model';

/**
 * Clase base con propiedades estándar para construir
 * otras clases de este archivo.
 *
 * @export
 * @class TramiteBase
 */
export class TramiteBase {
  id: number;
  nombre: string;
  descripcion: string;
}

/**
 * Todos los posibles estados que puede tener un trámite.
 * Este módelo complementa el de "Tramite".
 *
 * @export
 * @class TramiteEstado
 */
export class TramiteEstado extends TramiteBase {
  color?: string;
  old_id?: number;
}

/**
 * Trámite por default optimizado para la realización de filtros.
 *
 * Los endpoints que satisface son: defaultTramites.
 *
 * @export
 * @class TramiteDefaultCorto
 */
export class TramiteDefaultCorto extends TramiteBase {
  tramite_proceso: Proceso | number;
  tramite_estado: TramiteEstado | number;
}

/**
 * Instancia de un trámite por default.
 * Nota: Cuando se refiere a tramite tambien se refiere a los flujos del proceso secundario
 *
 * Los endpoints que satisface son: instanceDefaultTramite.
 *
 * @export
 * @class Tramite
 */
export class Tramite extends TramiteBase {
  tramite_estado: TramiteEstado;
  actividades: Actividad[];
  sede: Sede;
  expediente: Expediente;
  titulos: any;
}

/**
 * Complemento de el modelo de la consulta de la instancia del tramite
 *
 * @export
 * @class Expediente
 */
export class Expediente {
  codigo: string;
  expediente_estado: number;
  expediente_heredado: any;
  fecha_creacion: Date;
  fecha_registro: Date;
  id: number;
  id_expediente_cita: number;
}

/**
 * Tramite por default filtrado de a través del proceso.
 *
 * @export
 * @class TramiteProceso
 * @extends {TramiteBase}
 */
export class TramiteProceso extends TramiteBase {
  tramites: TramiteBase[];
}

/**
 * Flujo creado desde automatización de procesos.
 *
 * Los endpoints que satisface son: adminDefaultWorkflowTramite.
 *
 * @export
 * @class TramiteDefaultAdmin
 * @extends {TramiteBase}
 */
export class TramiteDefaultAdmin {
  tramite: Tramite;
  microproces: Microproceso[];

  constructor(values: Partial<TramiteDefaultAdmin>) {
    Static.setAll(this, values);
  }
}

/**
 * Modelo de la consulta del flujo de un tramite basico sin tanta informacion
 *
 * @export
 * @class TramiteBasico
 * @extends {TramiteBase}
 */
export class TramiteBasico extends TramiteBase {
  actividades: Actividad[];
}

/**
 * Consulta de los tramites activos por el tramite default
 *
 * @export
 * @class ConsultaTramite
 * @extends {TramiteBase}
 */
export class ConsultaTramite extends TramiteBase {
  tramite_estado: TramiteEstado;
  expediente: ExpedienteConsultaTramite;
  campos: CampoDinamico[];
}

/**
 * Modelo complementario dl modelo de la consulta de tramites en la instancia
 *
 * @export
 * @class ExpedienteConsultaTramite
 */
export class ExpedienteConsultaTramite {
  codigo: string;
  expediente_estado: TramiteBase;
  expediente_heredado: any;
  fecha_creacion: Date;
  fecha_registro: Date;
  id: number;
  id_expediente_cita: number;
  radicado_solicitud: string;
}

/**
 * Modelo de la informacion guardada del tramite por el titulo de la tarea
 *
 * @export
 * @class InformacionTramiteTarea
 * @extends {TramiteBase}
 */
export class InformacionTramiteTarea  extends TramiteBase {
  id_proceso_actual: number;
}

/**
 * Modelo de las observaciones de expedientes
 *
 * @export
 * @class ObservacionesExpediente
 */
export class ObservacioneExpediente {
  id: number;
  expediente: number;
  responsable: UsuarioBase;
  observacion: string;
  fecha: string;
  responsableCompleto?: string;
}

/**
 * Modelo complementario de las observaciones de expediente para el responsable
 * Usuario base de las observaciones
 *
 * @export
 * @class UsuarioBase
 */
export class UsuarioBase {
  id: number;
  nombre: string;
  apellido: string;
}

/**
 * Modelo de las etapas del tramite
 *
 * @export
 * @class Etapas
 */
export class Etapas {
  etapa_actual: EtapaActual;
  general: General;
}

/**
 * Modelo de la etapa atual del tramite
 *
 * @export
 * @class EtapaActual
 */
export class EtapaActual {
  nombre_de_la_etapa: string;
  estado_actual: string;
  dias_transcurridos_habiles: number;
  dias_transcurridos: number;
  duracion_etapa: number;
  habiles: boolean;
}

/**
 * Modelo de la etapa general del tramite
 *
 * @export
 * @class General
 */
export class General {
  estado_actual: string;
  dias_transcurridos: number;
  dias_transcurridos_habiles: number;
  duracion_estimada: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tramite.model.ts